import React, { Component } from 'react';
import Page from './page';

class Membership extends Component {

    render() {
        return (
            <Page />
        );
    }
}

export default Membership;